<template>
  <div class="ng-applicants">
    <el-table class="mb-x2" :data="ngApplicants" stripe @header-click="headerClick">
      <el-table-column label="ユーザー名" sort-by="-screenName" :render-header="renderHeader" min-width="40%">
        <template slot-scope="scope">{{ scope.row.screenName }}</template>
      </el-table-column>
      <el-table-column label="作成日時" sort-by="-created" :render-header="renderHeader" min-width="40%">
        <template slot-scope="scope">{{ formatDatetime(scope.row.created) }}</template>
      </el-table-column>
      <el-table-column min-width="10%">
        <template slot-scope="scope">
          <el-tooltip placement="top" content="削除">
            <el-button class="el-button--icon" type="default" @click="deleteNgApplicant(scope.row.id)"
              ><i class="mdi mdi-delete-forever"></i
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div layout layout-align="space-between-center">
      <pagination
        flex="1"
        type="NGアカウント"
        :total="options.total"
        :pagingNo="options.pagingNo"
        :limitCount="options.limitCount"
        :onChangePagingNo="onChangePagingNo"
        :onChangeLimitCount="onChangeLimitCount"
      ></pagination>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import Pagination from '@/client/components/_atoms/pagination'
import api from '@/client/core/api'
import Util from '@/client/core/util'
import { formatDatetime } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useSettingGroupStore } from '@/client/store/useSettingGroupStore'

export default defineComponent({
  components: {
    Pagination
  },
  props: {
    ngApplicants: Array,
    total: Number,
    options: Object,
    onChangeSortBy: Function,
    onChangePagingNo: Function,
    onChangeLimitCount: Function,
    snsType: String
  },
  methods: {
    formatDatetime,

    ...mapActions(useSettingGroupStore, ['fetchNgApplicants']),
    /**
     * NGアカウントを削除
     * @param {number} id
     */
    async deleteNgApplicant(id: number) {
      TrackingService.sendEvent('click:グループ設定|NGアカウント|削除')

      const confirm = window.confirm('NGアカウントを削除してよろしいですか？')
      if (!confirm) {
        return
      }

      const result = await api.delete(`/${this.snsType}_ng_applicants/${id}`)

      if (result.error && result.error.type === 'NOT_EXISTS') {
        return this.$notify({
          title: '対象のNGアカウントはすでに削除されています。',
          customClass: 'danger',
          duration: 5000
        })
      }

      if (result.error || !result.data) {
        return this.$notify({
          title: 'NGアカウントの削除に失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
      }

      this.$notify({
        title: 'NGアカウントを削除しました。',
        customClass: 'success',
        duration: 5000
      })

      const { shouldLeaveGroupSetting } = await this.fetchNgApplicants(this.snsType)

      if (shouldLeaveGroupSetting) {
        this.$router.push('/campaigns')
      }
    },
    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case 'ユーザー名':
          TrackingService.sendEvent('sort:グループ設定|NGアカウント|ユーザー名')
          break
        case '作成日時':
          TrackingService.sendEvent('sort:グループ設定|NGアカウント|作成日時')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },

    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(createElement, column.label, Util.getSortClass(this.options.sortBy, column.sortBy))
    }
  }
})
</script>
